import React from "react";
import { useNavigate } from "react-router-dom";

export default function AppAziendaHomePage() {
  const navigate = useNavigate();
  const username = localStorage.getItem("me.username") || "";

  const logout = () => {
    ["access", "refresh", "me.username", "me.role",
     "me.store_name", "session_only"].forEach((key) =>
      localStorage.removeItem(key)
    );
    ["access", "refresh"].forEach((key) =>
      sessionStorage.removeItem(key)
    );
    window.location.replace("/app");
  };

  const cardStyle = {
    border: 0,
    borderRadius: 18,
    boxShadow: "0 4px 18px rgba(0,0,0,0.07)",
  };

  const sezioni = [
    {
      titolo: "Catalogo aziende",
      descrizione: "Scopri i prodotti e i prezzi riservati alla tua attività.",
      percorso: "/app/azienda/catalogo",
      pulsante: "Apri catalogo",
    },
    {
      titolo: "Promozioni aziende",
      descrizione: "Scopri le offerte e i vantaggi riservati alla tua attività.",
      percorso: "/app/azienda/promozioni",
      pulsante: "Scopri le promozioni",
    },
    {
      titolo: "Nuovo ordine",
      descrizione: "Seleziona i prodotti e prepara un nuovo ordine.",
      percorso: "/app/azienda/ordini/nuovo",
      pulsante: "Crea ordine",
    },
    {
      titolo: "I miei ordini",
      descrizione: "Consulta gli ordini effettuati dalla tua azienda.",
      percorso: "/app/azienda/ordini",
      pulsante: "Visualizza ordini",
    },
  ];

  return (
    <div className="container py-4" style={{ maxWidth: 760 }}>
      <div className="mb-4">
        <div className="small text-uppercase text-muted fw-bold">
          Area Azienda
        </div>
        <h2 className="fw-bold mb-1">Dallo Zio Roby</h2>
        {username && (
          <div className="text-muted">Account: {username}</div>
        )}
      </div>

      <div className="d-flex flex-column gap-3">
        {sezioni.map((sezione) => (
          <div className="card" style={cardStyle} key={sezione.percorso}>
            <div className="card-body p-4">
              <h4 className="fw-bold">{sezione.titolo}</h4>
              <p className="text-muted">{sezione.descrizione}</p>
              <button
                type="button"
                className="btn btn-dark rounded-pill w-100 py-2"
                onClick={() => navigate(sezione.percorso)}
              >
                {sezione.pulsante}
              </button>
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="btn btn-outline-secondary rounded-pill w-100 mt-4"
        onClick={logout}
      >
        Esci dall'account
      </button>
    </div>
  );
}
